// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__3p55H","collapse":"styles_collapse__1KVAw","childrenWrapper":"styles_childrenWrapper__vDUg-"};